export const environment = {
  production: true,
  urlServices: window.location.origin + '/mares-reconocimientos-back/'

  // urlServices: 'https://asone.udea.edu.co/reconocimientos-webservice/'
};
